module.exports = __webpack_public_path__ + "assets/img/fairown-lawnmower.9c2624ed.jpg";